// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Verification Notice */\n\n#verification-notice .title-notice{\n  font-family: 'Regular Intro Bold';\n  font-size: 2.2em;\n  text-shadow: 2px 2px rgba(0, 0, 0, 0.2);\n  color:#000;\n}\n\n#verification-notice .subtitle-notice{\n  font-size: 1.6em;\n}", ""]);
// Exports
module.exports = exports;
